class LanguageService {

    static getLang() {
        return localStorage.getItem('language')
    }

    static setLang(lang) {
        localStorage.setItem('language', lang)
    }
}
export default LanguageService;